import { render, staticRenderFns } from "./CustomerListBar.vue?vue&type=template&id=44a08351&scoped=true"
import script from "./CustomerListBar.vue?vue&type=script&lang=js"
export * from "./CustomerListBar.vue?vue&type=script&lang=js"
import style0 from "./CustomerListBar.vue?vue&type=style&index=0&id=44a08351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a08351",
  null
  
)

export default component.exports